import {z} from '@hono/zod-openapi';

export const advertisingMappingStatsRowSchema = z
  .object({
    targetPath: z.string(),
    totalCount: z.number().int().nonnegative(),
    successCount: z.number().int().nonnegative(),
    failureCount: z.number().int().nonnegative(),
    missingCount: z.number().int().nonnegative(),
    skippedCount: z.number().int().nonnegative(),
    lastErrorAt: z.string().datetime().nullable(),
  })
  .openapi('AdvertisingMappingStatsRow');
